import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { twMerge } from '../../utils/twMerge.js';
/**
 * A simple flex container with a gap to add spacing between buttons. Mainly exists to map to the same component in Figma.
 */
export const ButtonGroup = forwardRef(function ButtonGroup(props, forwardedRef) {
    return (_jsx("div", { ...props, ref: forwardedRef, className: twMerge('ppl-ButtonGroup flex flex-row items-center gap-2', props.className) }));
});
//# sourceMappingURL=ButtonGroup.js.map